import React from 'react';
import { Layout, Menu, Icon } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getPerm } from 'utils/helpers';
import { compose, withProps } from 'recompose';
import defaultImage from 'theme/images/default-img.png';
import { path } from 'utils/media';
import colors from 'theme/colors';

const SubMenu = Menu.SubMenu;

const enhance = compose(
  connect(
    state => ({
      permissions: state.auth.permissions,
      user: state.auth.user,
      isLoggedIn: state.auth.loggedIn
    }),
    {}
  ),
  withProps(
    (ownProps) => ({
      perm: {
        topic: getPerm([
          'topic.article.view',
          'topic.city.view',
          'topic.topic.view',
          'topic.highlight.view',
          'topic.search.view'
        ], ownProps.permissions),
        config: getPerm('config.view', ownProps.permissions),
        customize: getPerm('customize.view', ownProps.permissions),
        calendar: getPerm([
          'calendar.booking.view',
          'calendar.lxAvailability.view'
        ], ownProps.permissions),
        payment: getPerm(['payment.view'], ownProps.permissions),
        trip: getPerm([
          'trip.tripGroup.view',
          'trip.approvedTrips.view',
        ], ownProps.permissions),
        booking: getPerm(['booking.view'], ownProps.permissions),
        partner: getPerm(['partner.view'], ownProps.permissions),
        redeem: getPerm(['redeem.view', 'redeem.edit'], ownProps.permissions),
        redirect: getPerm(['redirect.view', 'redirect.edit'], ownProps.permissions),
        affiliate: getPerm(['affiliate.view', 'affiliate.edit'], ownProps.permissions),
        influencer: getPerm(['influencer.vaiew', 'influencer.edit'], ownProps.permissions),
        review: getPerm(['review.view', 'review.edit'], ownProps.permissions),
        localtable: getPerm([
          'localtable.restaurant.view',
          'localtable.restaurant.edit',
          'localtable.souvenir.view',
          'localtable.souvenir.edit',
        ], ownProps.permissions),
        biennale: getPerm([
          'biennale.view',
          'biennale.edit',
        ], ownProps.permissions),
        pricing: getPerm([
          'pricing.view',
          'pricing.edit',
        ], ownProps.permissions),
        sms: getPerm([
          'sms.send',
        ], ownProps.permissions),
        fruitMarket: getPerm([
          'fruitMarket.recommandation.edit',
          'fruitMarket.sellers.view',
          'fruitMarket.sellers.edit',
          'fruitMarket.orders.view',
          'fruitMarket.orders.edit',
        ], ownProps.permissions),
        localCommunities: getPerm([
          'localCommunities.view',
          'localCommunities.edit',
        ], ownProps.permissions),
        walkingTour: getPerm([
          'walkingTour.view',
          'walkingTour.bookings.view',
          'walkingTour.refunds.approve',
          'walkingTour.refunds.reject',
        ], ownProps.permissions),
      }
    })
  ),
);
const FixedSider = styled(Layout.Sider)`
  position: fixed !important;
  height: 100%;
  left: 0;
  z-index: 2;
  > div {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 120px;
  min-height: 120px;
  width: 100%;
  > h3 {
    color: ${colors.white};
  }
`;
const ProfilePic = styled.div`
  width: 80px;
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  background-image: ${props => (props.src ? `url('${path(props.src, 'avatarTripCard')}')` : `url('${defaultImage}')`)};
  background-size: cover;
  background-position: 50%;
  border-radius: 50%;
`;
const NavScroll = styled.div`
  max-height: 100%;
  overflow-y: auto;
  flex: 1;
`;

const SiderNav = props => {
  const { perm, user, isLoggedIn } = props;
  return (
    <FixedSider
      breakpoint="sm"
      collapsedWidth="0"
    >
      {isLoggedIn && (
        <ProfileContainer>
          <ProfilePic src={user.avatar_image} />
          <h3>{user.name && user.name.first}</h3>
        </ProfileContainer>
      )}
      <NavScroll>
        <Menu theme="dark" mode="inline">
          {perm.topic.length > 0 &&
            <SubMenu key="topic" title={<span><Icon type="switcher" /><span>Sections & Topics</span></span>}>
              {perm.topic.indexOf('topic.topic.view') >= 0 && <Menu.Item key="topic.dashboard">
                <Link to="/topic/dashboard">Dashboard</Link>
              </Menu.Item>}
              {perm.topic.indexOf('topic.topic.view') >= 0 &&
                <Menu.Item key="topic.topic">
                  <Link to="/topic">Topics</Link>
                </Menu.Item>
              }
              {perm.topic.indexOf('topic.article.view') >= 0 &&
                <Menu.Item key="topic.article">
                  <Link to="/article">Articles</Link>
                </Menu.Item>
              }
              {perm.topic.indexOf('topic.city.view') >= 0 &&
                <Menu.Item key="topic.city">
                  <Link to="/city">Cities</Link>
                </Menu.Item>
              }
              {perm.topic.indexOf('topic.highlight.view') >= 0 &&
                <Menu.Item key="topic.highlight">
                  <Link to="/highlight">Highlights</Link>
                </Menu.Item>
              }
              {perm.topic.indexOf('topic.search.view') >= 0 &&
                <Menu.Item key="topic.search">
                  <Link to="/search-n-replace">Search & Replace</Link>
                </Menu.Item>
              }
            </SubMenu>
          }
          {perm.trip.length > 0 &&
            <SubMenu key="trip" title={<span><Icon type="picture" /><span>Trip</span></span>}>
              {perm.trip.indexOf('trip.tripGroup.view') >= 0 &&
                <Menu.Item key="tripGroups">
                  <Link to="/trip-group">
                    <Icon type="appstore" />
                    <span className="nav-text">Trip Group</span>
                  </Link>
                </Menu.Item>
              }
              {perm.trip.indexOf('trip.approvedTrips.view') >= 0 &&
                <Menu.Item key="approvedTrips">
                  <Link to="/approved-trips">
                    <Icon type="check-circle-o" />
                    <span className="nav-text">Approved Trips</span>
                  </Link>
                </Menu.Item>
              }
            </SubMenu>
          }
          {perm.booking.length > 0 &&
            <SubMenu key="bookingDashboard" title={<span><Icon type="inbox" /><span className="nav-text">Booking Dashboard</span></span>}>
              <Menu.Item key="booking.dashboard">
                <Link to="/booking/dashboard">Booking Dashboard</Link>
              </Menu.Item>
              <Menu.Item key="booking.dashboard.promo.code">
                <Link to="/booking/promo-code">Booking Promo code</Link>
              </Menu.Item>
              <Menu.Item key="booking.dashboard.manual.booking">
                <Link to="/booking/manual-booking">Manual Booking</Link>
              </Menu.Item>
            </SubMenu>
          }
          {perm.partner.length > 0 &&
            <SubMenu key="partner" title={<span><Icon type="fork" /><span className="nav-text">Partner</span></span>}>
              <Menu.Item key="partner.availability">
                <Link to="/partner/availability">Availability</Link>
              </Menu.Item>
            </SubMenu>
          }
          {perm.booking.length > 0 &&
            <Menu.Item key="swapRequest">
              <Link to="/swap-request">
                <Icon type="retweet" />
                <span className="nav-text">Swap Request</span>
              </Link>
            </Menu.Item>
          }
          {perm.config.length > 0 &&
            <SubMenu key="config" title={<span><Icon type="setting" /><span>Site Config</span></span>}>
              <Menu.Item key="config.redirect">
                <Link to="/redirect">Redirect</Link>
              </Menu.Item>
              <Menu.Item key="config.config">
                <Link to="/config">Configs</Link>
              </Menu.Item>
              <Menu.Item key="config.configKey">
                <Link to="/config-key">Config Keys</Link>
              </Menu.Item>
              <Menu.Item key="config.testing">
                <Link to="/testing">A/B Testing</Link>
              </Menu.Item>
              <Menu.Item key="config.translation">
                <Link to="/translation">Translation</Link>
              </Menu.Item>
              <Menu.Item key="config.assignee">
                <Link to="/assignee">Assignee</Link>
              </Menu.Item>
              <Menu.Item key="config.meetingPoint">
                <Link to="/meeting-point">Meeting Points</Link>
              </Menu.Item>
            </SubMenu>
          }
          {perm.payment.length > 0 && (
            <SubMenu key="payment" title={<span><Icon type="credit-card" /><span>Payment</span></span>}>
              <Menu.Item key="payment.payout">
                <Link to="/payment/export">Export Payout</Link>
              </Menu.Item>
              <Menu.Item key="payment.statement">
                <Link to="/payment/statement">Statement</Link>
              </Menu.Item>
              <Menu.Item key="payment.refund">
                <Link to="/refund/pending">Pending Refund</Link>
              </Menu.Item>
              <Menu.Item key="payment.history">
                <Link to="/payment/history">Payment History</Link>
              </Menu.Item>
              <Menu.Item key="payment.manual">
                <Link to="/payment/manual">Manual Payment</Link>
              </Menu.Item>
            </SubMenu>
          )}
          {perm.calendar.length > 0 && (
            <SubMenu key="calendar" title={<span><Icon type="calendar" /><span>Calendar</span></span>}>
              {perm.calendar.indexOf('calendar.booking.view') >= 0 && (
                <Menu.Item key="calendar.booking">
                  <Link to="/calendar">
                    <span className="nav-text">Booking Calendar</span>
                  </Link>
                </Menu.Item>
              )}
              {perm.calendar.indexOf('calendar.lxAvailability.view') >= 0 && (
                <Menu.Item key="calendar.lxAvailability">
                  <Link to="/lx-availability">
                    <span className="nav-text">LX Availability Calendar</span>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>
          )}
          {perm.walkingTour.length > 0 && (
            <SubMenu key="walkingTour" title={<span><Icon type="environment-o" /><span>Walking Tour</span></span>}>
              <Menu.Item key="walkingTour.product">
                <Link to="/walking-tour/products">
                  <span className="nav-text">Products</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="walkingTour.booking">
                <Link to="/walking-tour/bookings">
                  <span className="nav-text">Booking</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="walkingTour.manageAvailability">
                <Link to="/walking-tour/manage-availability">
                  <span className="nav-text">Manage Availability</span>
                </Link>
              </Menu.Item>
            </SubMenu>
          )}
          {perm.fruitMarket.length > 0 && (
            <SubMenu key="fruitMarket" title={<span><Icon type="shopping-cart" /><span>Fruit Market</span></span>}>
              {perm.fruitMarket.indexOf('fruitMarket.recommandation.edit') >= 0 && (
                <Menu.Item key="fruitMarket.recommandation">
                  <Link to="/fruit-market/recommandation">
                    <span className="nav-text">Recommandation</span>
                  </Link>
                </Menu.Item>
              )}
              {perm.fruitMarket.indexOf('fruitMarket.sellers.view') >= 0 && (
                <Menu.Item key="fruitMarket.seller">
                  <Link to="/fruit-market/seller">
                    <span className="nav-text">Sellers</span>
                  </Link>
                </Menu.Item>
              )}
              {perm.fruitMarket.indexOf('fruitMarket.orders.view') >= 0 && (
                <Menu.Item key="fruitMarket.order">
                  <Link to="/fruit-market/order">
                    <span className="nav-text">Orders</span>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>
          )}
          {perm.localCommunities.length > 0 && (
            <Menu.Item key="local-community">
              <Link to="/local-community">
                <Icon type="home" />
                <span className="nav-text">Local Community</span>
              </Link>
            </Menu.Item>
          )}
          {perm.redeem.length > 0 &&
            <Menu.Item key="redeem">
              <Link to="/redeem">
                <Icon type="gift" />
                <span className="nav-text">Redeem</span>
              </Link>
            </Menu.Item>
          }
          {perm.customize.length > 0 &&
            <Menu.Item key="customize">
              <Link to="/customize">
                <Icon type="customer-service" />
                <span className="nav-text">Customize</span>
              </Link>
            </Menu.Item>
          }
          {perm.review.length > 0 && (
            <Menu.Item key="review">
              <Link to="/review">
                <Icon type="star" />
                <span className="nav-text">Review</span>
              </Link>
            </Menu.Item>
          )}
          {perm.affiliate.length > 0 && (
            <SubMenu key="affiliate" title={<span><Icon type="user" /><span>Affiliate</span></span>}>
              <Menu.Item key="affiliate.report">
                <Link to="/affiliate/report">Report</Link>
              </Menu.Item>
              <Menu.Item key="affiliate.payment">
                <Link to="/affiliate/payment">Payment</Link>
              </Menu.Item>
              <Menu.Item key="affiliate.users">
                <Link to="/affiliate/users">Users</Link>
              </Menu.Item>
            </SubMenu>
          )}
          {perm.influencer.length > 0 && (
            <SubMenu key="influencer" title={<span><Icon type="user" /><span>Influencer</span></span>}>
              <Menu.Item key="influencer.users">
                <Link to="/influencer/users">Users</Link>
              </Menu.Item>
            </SubMenu>
          )}
          {/* {perm.localtable.length > 0 && (
            <SubMenu key="localtable" title={<span><Icon type="shopping-cart" /><span>LocalTable</span></span>}>
              <Menu.Item key="localtable.restaurant">
                <Link to="/restaurant">Restaurant</Link>
              </Menu.Item>
              <Menu.Item key="localtable.souvenir">
                <Link to="/souvenir">Souvenir</Link>
              </Menu.Item>
            </SubMenu>
          )}
          {perm.biennale.length > 0 && (
            <SubMenu key="biennale" title={<span><Icon type="picture" /><span>Biennale</span></span>}>
              <Menu.Item key="biennale.artist">
                <Link to="/biennale/artist">Artist</Link>
              </Menu.Item>
              <Menu.Item key="biennale.art">
                <Link to="/biennale/art">Arts</Link>
              </Menu.Item>
              <Menu.Item key="biennale.artPlan">
                <Link to="/biennale/art-plan">Art Plan</Link>
              </Menu.Item>
              <Menu.Item key="biennale.artCommunity">
                <Link to="/biennale/art-community">Art Community</Link>
              </Menu.Item>
            </SubMenu>
          )} */}
          {perm.pricing.length > 0 && (
            <Menu.Item key="pricing">
              <Link to="/pricing">
                <Icon type="pay-circle-o" />
                Pricing
              </Link>
            </Menu.Item>
          )}
          {perm.sms.length > 0 && (
            <Menu.Item key="sms">
              <Link to="/send-sms">
                <Icon type="message" />
                <span className="nav-text">Send SMS</span>
              </Link>
            </Menu.Item>
          )}
          {/* Gated on is_admin rather than a `getPerm` string: the backend route
              behind this screen is `auth.admin`, and no permission for it is
              issued yet — a `getPerm('cxHandoff.view')` check would hide the
              menu item from everyone. */}
          {user && user.is_admin && (
            <Menu.Item key="cx-handoff">
              <Link to="/cx-handoff">
                <Icon type="customer-service" />
                <span className="nav-text">CX Handoff</span>
              </Link>
            </Menu.Item>
          )}
          <Menu.Item key="logout">
            <Link to="/logout">
              <Icon type="logout" />
              <span className="nav-text">Logout</span>
            </Link>
          </Menu.Item>
        </Menu>
      </NavScroll>
    </FixedSider>
  );
};

SiderNav.__ANT_LAYOUT_SIDER = true;

export default enhance(SiderNav);



// WEBPACK FOOTER //
// ./src/components/Nav/SiderNav/index.js